import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'smt-excel-export-warning-dialog',
  templateUrl: './excel-export-warning.dialog.html',
  styleUrls: ['./excel-export-warning.dialog.scss'],
  host: { class: 'smt-excel-export-warning-dialog' },
  encapsulation: ViewEncapsulation.None
})
export class ExcelExportWarningDialog {}